import Icon from '@/components/ui/AppIcon';

export default function BenefitsSection() {
  const features = [
    {
      id: 'feature_1',
      icon: 'FireIcon',
      title: 'Realistic flame-effect LED lighting',
    },
    {
      id: 'feature_2',
      icon: 'SparklesIcon',
      title: 'Ultrasonic aroma mist',
    },
    {
      id: 'feature_3',
      icon: 'SpeakerXMarkIcon',
      title: 'Whisper-quiet operation',
    },
    {
      id: 'feature_4',
      icon: 'ShieldCheckIcon',
      title: 'Safe — no real fire, no heat',
    },
    {
      id: 'feature_5',
      icon: 'BeakerIcon',
      title: 'Essential oil compatible',
    },
    {
      id: 'feature_6',
      icon: 'BoltIcon',
      title: 'UK plug compatible',
    },
  ]

  return (
    <section className="py-32 px-6 bg-card reveal">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="flex items-start gap-4 group"
            >
              <div className="w-6 h-6 flex-shrink-0 text-primary mt-1">
                <Icon name={feature.icon as any} size={24} className="text-primary" />
              </div>
              <p className="text-lg text-foreground">{feature.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}